module.exports = __webpack_public_path__ + "assets/img/32-l.736cf6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/32-l.jpg
// module id = RvJQ
// module chunks = 0